export default __webpack_public_path__ + "static/media/NotoSerif-Italic.2caa48ad.woff2";